/**
 * Family Form Page
 */

import { FolderTree } from 'lucide-react'
import { CatalogFormPage } from './CatalogFormPage'
import { useTranslation } from '@/hooks/useTranslation'

export function FamilyFormPage() {
  const { t } = useTranslation()

  return (
    <CatalogFormPage
      config={{
        endpoint: 'families',
        basePath: '/families',
        title: t('catalogs.families'),
        newTitle: t('catalogs.newFamily'),
        editTitle: t('catalogs.editFamily'),
        icon: FolderTree,
        fields: [
          { key: 'code', label: t('articles.code'), type: 'text' },
          { key: 'description', label: t('articles.description'), type: 'text', required: true },
        ],
      }}
    />
  )
}
